import { AppName } from 'data/lib/mini-app-constants';
import { getApp } from 'owa-config/lib/bootstrapOptions';
import { getPathPrefix } from 'mini-module-switcher/lib/utils/onModuleSwitcherItemClick';
import { Module } from 'mini-module-switcher';

export function getCurrentAppBasePath(): { searchQuery: string; pathPrefix: any } {
    const bootStrappedApp = getApp();
    switch (bootStrappedApp) {
        case AppName.CALENDAR:
            return getPathPrefix(Module.Calendar);
        case AppName.PEOPLE:
            return getPathPrefix(Module.People);
        case AppName.MAIL:
        default:
            return getPathPrefix(Module.Mail);
    }
}
